/*
 * Jira Ticket:
 * Created Date: Wed, 15th Apr 2020, 09:01:02 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';
import { getManyEmployment } from 'DataProvider/queries';

export const getListUserQuery = gql`
  query allUsers(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: UserFilter
  ) {
    items: allUsers(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      id
      email
      familyName
      givenName
      certificateNumber
      isAdmin
      hasAccount
      status
    }
    total: _allUsersMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
    }
  }
`;

export default async ({ client, params }) => {
  try {
    if (Object.keys(params.filter).length === 0) {
      params.filter = {
        status: 'active',
      };
    }
    const allUsersResponse = await client.query({
      query: getListUserQuery,
      variables: {
        filter: params.filter,
        sortField: params.sort.field,
        sortOrder: params.sort.order,
        page: !params.pagination.page ? 0 : params.pagination.page - 1,
        perPage: params.pagination.perPage,
      },
      fetchPolicy: 'network-only',
    });
    // we need to now go get the employments for each user
    const userData = allUsersResponse.data.items;
    const userIds = allUsersResponse.data.items
      .filter(user => !user.isAdmin)
      .map(user => user.id); // do not request super admin employment data
    // const userEmails = allUsersResponse.data.items
    //   .filter(user => !user.isAdmin)
    //   .map(user => user.email); // do not request super admin employment data
    if (userIds && userIds.length > 0) {
      const filteredEmploymentResponse = await getManyEmployment({
        client,
        params: {
          filter: { userIds },
          pagination: { perPage: 1000 },
        },
      });
      const employmentData = filteredEmploymentResponse.data.items;
      userData.forEach(user => {
        let assignedProjects = [];
        let assignedOrganisations = [];
        const filteredList = employmentData.filter(
          employment => employment.user.id === user.id
        );
        filteredList.forEach(userEmployment => {
          if (userEmployment.projects && userEmployment.projects.length > 0) {
            userEmployment.projects.forEach(project => {
              assignedProjects.push({
                ...project,
                status: userEmployment.status,
              });
            });
          }
          assignedOrganisations.push({
            ...userEmployment.organisation,
            status: userEmployment.status,
          });
        });
        user.assignedProjects = assignedProjects;
        user.assignedOrganisations = assignedOrganisations;
      });
    }
    allUsersResponse.data.items = userData;
    return allUsersResponse;
  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length) {
      const [error] = e.graphQLErrors;
      const message = error.message;
      throw new Error(message);
    }
    throw e;
  }
};
